// The admin console is a separate app: the tenant app lives on the bare tenant
// domain, the console on the `admin.` subdomain (ports 5173/5174 in dev).
// Mirror of buildAppUrl in app/admin.
export function buildAdminOrgUrl(orgId: string): string {
  const configuredUrl = (import.meta.env.VITE_ADMIN_FRONTEND_URL as string | undefined)?.trim();
  if (configuredUrl) {
    return `${configuredUrl.replace(/\/+$/, '')}/organisations/${encodeURIComponent(orgId)}`;
  }

  const { protocol, hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://${hostname}:5174/organisations/${encodeURIComponent(orgId)}`;
  }

  return `${protocol}//admin.${hostname}/organisations/${encodeURIComponent(orgId)}`;
}

// Opens the console in a new tab so the app keeps its own history: navigating
// away in-place left the back button returning to a dead redirect page.
export function openAdminOrgSettings(orgId: string): void {
  window.open(buildAdminOrgUrl(orgId), '_blank', 'noopener,noreferrer');
}
